import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./Login.css";

const Login = ({ onLoginSuccess }) => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [gu, setGu] = useState("1");

  useEffect(() => {
    const savedId = Cookies.get("id");
    const savedGu = Cookies.get("gu");

    if (savedId && savedGu) {
      setId(savedId);
      setGu(savedGu);
      setRememberMe(true);
    }
  }, []);

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;

  // Login.jsx (핵심만)
const handleSubmit = async (e) => {
  e.preventDefault();

  if (id === "" || password === "" || gu === "") {
    setError("아이디, 비밀번호를 입력하세요.");
    return;
  }

  setError("");

  try {
    const res = await fetch(`${serverUrl}/api/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, password, gu }),
    });

    const data = await res.json();
    console.log("로그인 응답:", data);

    if (!data.success) {
      // 🔴 backend에서 내려준 메시지 그대로 표시
      setError(data.error || "로그인 실패");
      return;
    }

    Cookies.remove("id");
    Cookies.remove("gu");

    if (rememberMe) {
      Cookies.set("id", id, { expires: 3650, path: "/" });
      Cookies.set("gu", gu, { expires: 3650, path: "/" });
    }

    // 🔵 성공 처리
    onLoginSuccess(
      data.BCE_CODE,
      data.BCE_NAME,
      data.GU,
      data.BCU_CODE,
      data.BCU_NAME,
      data.SYSTEMYN
    );

  } catch (err) {
    setError(err.message || "로그인 실패");
  }
};

  return (
    <div className="login-container">
      <h1>IZEN IMPLANT</h1>
      {/* <img src="/images/logo.png" alt="IZEN" className="logo" /> */}
      <h2>로그인</h2>

      <div className="user-type-container">
        <label>
          <input
            type="radio"
            name="gu"
            value="1"
            checked={gu === "1"}
            onChange={(e) => setGu(e.target.value)}
          />
          개인
        </label>
        <label>
          <input
            type="radio"
            name="gu"
            value="2"
            checked={gu === "2"}
            onChange={(e) => setGu(e.target.value)}
          />
          기업
        </label>
      </div>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-container">
          <label>아이디</label>
          <input
            type="text"
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="아이디을 입력하세요"
          />
        </div>

        <div className="input-container">
          <label>비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호를 입력하세요"
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="input-container remember-me-container">
          <label>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            아이디 저장
          </label>
        </div>

        <button type="submit" className="login-button">
          로그인
        </button>
      </form>
    </div>
  );
};

export default Login;
